import { Link, NavLink, Outlet, useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { portalApi } from '../utils/portalApi';

const navItems = [
  { label: 'Dashboard', to: '/dashboard' },
  { label: 'Articles', to: '/articles' }
];

export default function PortalLayout() {
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    portalApi.getSession().then(() => setLoading(false)).catch(() => navigate('/login'));
  }, [navigate]);

  const handleLogout = async () => {
    try {
      await portalApi.logout();
    } finally {
      navigate('/login');
    }
  };

  if (loading) return <main className="min-h-screen grid place-items-center text-slate-600">Checking session…</main>;

  return (
    <div className="min-h-screen bg-slate-50">
      <header className="border-b bg-white">
        <div className="mx-auto flex max-w-6xl items-center justify-between px-4 py-4 md:px-6">
          <Link to="/dashboard" className="font-semibold text-cam-blue">CarterAM Employee Portal</Link>
          <button onClick={handleLogout} className="rounded-md border px-3 py-1.5 text-sm text-slate-700 hover:bg-slate-100">Log out</button>
        </div>
      </header>
      <div className="mx-auto grid max-w-6xl gap-6 px-4 py-8 md:grid-cols-[220px_1fr] md:px-6">
        <aside className="rounded-xl bg-white p-3 ring-1 ring-slate-200">
          <nav className="space-y-1" aria-label="Employee navigation">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                className={({ isActive }) => `block rounded-md px-3 py-2 text-sm ${isActive ? 'bg-cam-blue/10 font-semibold text-cam-blue' : 'text-slate-700 hover:bg-slate-50'}`}
              >
                {item.label}
              </NavLink>
            ))}
          </nav>
          <Link to="/articles/new" className="mt-3 block rounded-md bg-cam-blue px-3 py-2 text-center text-sm font-medium text-white hover:bg-cam-blue/90">Create New Article</Link>
        </aside>
        <main>
          <Outlet />
        </main>
      </div>
    </div>
  );
}
